/* Field & Lab — content portal behavior (sections/jiec-field-and-lab.liquid) */
(function () {
  'use strict';

  var reduceMotion = false;
  try { reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var behavior = reduceMotion ? 'auto' : 'smooth';

  function norm(s) {
    return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function icon(name, size) {
    var paths = {
      next: '<path d="M9 6l6 6-6 6"/>',
      image: '<rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="9" cy="10" r="1.6"/><path d="M21 16l-5-5-8 8"/>',
      bottle: '<path d="M10 2h4v3h-4z"/><path d="M9 5h6v3l2 2v10a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V10l2-2z"/>',
      play: '<path d="M8 5v14l11-7z" fill="currentColor" stroke="none"/>'
    };
    var s = size || 18;
    var w = document.createElement('span');
    w.innerHTML = '<svg class="flab-icon" width="' + s + '" height="' + s + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + (paths[name] || '') + '</svg>';
    return w.firstChild;
  }
  function headerVisibleHeight() {
    var h = document.querySelector('.section-header');
    if (!h) return 0;
    if (h.classList.contains('shopify-section-header-sticky') && !h.classList.contains('shopify-section-header-hidden')) return h.offsetHeight;
    return 0;
  }

  /* On this page the site header slides away on scroll down (see the section's inline script).
     The theme brings it back on any scroll up; this waits for a deliberate scroll up instead. */
  var guard = null;
  function headerGuard(distance) {
    if (guard) return guard;
    var sticky = document.querySelector('sticky-header');
    var header = document.querySelector('.section-header');
    if (!distance || !sticky || !header || !document.documentElement.classList.contains('flab-header-hides')) return null;
    var lastY = window.pageYOffset, up = 0, holding = false, holdTimer = null;
    var hidden = function () { return header.classList.contains('shopify-section-header-hidden'); };
    // Capture phase on window runs before the theme's own scroll handler for the same scroll.
    window.addEventListener('scroll', function () {
      var y = window.pageYOffset;
      var dy = y - lastY;
      lastY = y;
      if (holding) {
        up = 0;
        if (hidden()) sticky.preventReveal = true;
        clearTimeout(holdTimer);
        holdTimer = setTimeout(function () { holding = false; }, 150);
        return;
      }
      if (dy > 0 || !hidden()) { up = 0; return; }
      if (dy === 0) return;
      up -= dy;
      if (up < distance) {
        sticky.preventReveal = true;
      } else {
        sticky.preventReveal = false;
        clearTimeout(sticky.isScrolling);
      }
    }, { capture: true, passive: true });
    guard = {
      // Keep the header tucked away while the page scrolls to a collection.
      hold: function () {
        holding = true;
        up = 0;
        clearTimeout(holdTimer);
        holdTimer = setTimeout(function () { holding = false; }, 300);
      }
    };
    return guard;
  }

  // Height of the site header that will sit over the page when a jump finishes.
  function headerOverlap(goingUp) {
    var hdr = document.querySelector('.section-header');
    var st = document.querySelector('sticky-header');
    if (!hdr || !st) return 0;
    var type = st.getAttribute('data-sticky-type');
    if (type === 'always' || type === 'reduce-logo-size') return hdr.offsetHeight;
    if (!goingUp) return 0;
    if (hdr.classList.contains('shopify-section-header-hidden')) {
      if (guard) { guard.hold(); return 0; }
      return hdr.offsetHeight;
    }
    return hdr.classList.contains('shopify-section-header-sticky') ? hdr.offsetHeight : 0;
  }

  function init(root) {
    if (root.__flab) return;
    root.__flab = true;

    var bar = root.querySelector('[data-flab-bar]');
    var sentinel = root.querySelector('[data-flab-sentinel]');
    var chipsNav = root.querySelector('[data-flab-chips]');
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-flab-chip]'));
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-flab-row]'));
    var sheet = root.querySelector('[data-flab-sheet]');
    var search = root.querySelector('[data-flab-search]');
    var toast = root.querySelector('[data-flab-toast]');
    var topBtn = root.querySelector('[data-flab-top]');
    var shareBase = root.getAttribute('data-flab-share-base') || (location.origin + location.pathname);
    var picks = (root.getAttribute('data-flab-picks') || '').split('|').filter(Boolean);
    headerGuard(parseInt(root.getAttribute('data-flab-reveal') || '0', 10));

    var products = {};
    try { products = JSON.parse(root.querySelector('[data-flab-products]').textContent); } catch (e) {}

    var items = [];
    var byId = {};
    Array.prototype.forEach.call(root.querySelectorAll('[data-flab-json]'), function (slot, i) {
      try {
        var d = JSON.parse(slot.getAttribute('data-flab-json'));
        d.o = (d.o || []).filter(Boolean);
        d.p = (d.p || []).filter(Boolean);
        d.order = i;
        d.n = norm([d.t, d.m, d.rt, d.ol, (d.k || []).join(' ')].join(' '));
        if (!byId[d.id]) { items.push(d); byId[d.id] = d; }
      } catch (e) {}
    });

    var lastFocus = null;
    var openLayer = null;
    var currentItem = null;

    /* ---------- Layers (preview sheet, search) ---------- */
    function trap(e) {
      if (!openLayer) return;
      if (e.key === 'Escape') { e.preventDefault(); closeLayer(); return; }
      if (e.key !== 'Tab') return;
      var f = openLayer.querySelectorAll('a[href]:not([hidden]), button:not([disabled]):not([hidden]), input, [tabindex]:not([tabindex="-1"])');
      var list = Array.prototype.filter.call(f, function (n) { return n.offsetParent !== null; });
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    function showLayer(layer) {
      if (openLayer && openLayer !== layer) openLayer.hidden = true;
      if (!openLayer) lastFocus = document.activeElement;
      openLayer = layer;
      layer.hidden = false;
      document.documentElement.classList.add('flab-lock');
      document.addEventListener('keydown', trap);
    }
    function closeLayer() {
      if (!openLayer) return;
      openLayer.hidden = true;
      openLayer = null;
      currentItem = null;
      document.documentElement.classList.remove('flab-lock');
      document.removeEventListener('keydown', trap);
      setOpenParam(null);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-flab-close]'), function (b) {
      b.addEventListener('click', closeLayer);
    });

    function setOpenParam(id) {
      try {
        var u = new URL(location.href);
        if (id) u.searchParams.set('open', id); else u.searchParams.delete('open');
        history.replaceState(history.state, '', u.toString());
      } catch (e) {}
    }

    /* ---------- Preview sheet ---------- */
    var blendHandle = root.getAttribute('data-flab-blend') || '';
    function productLabel(it) {
      if (!it.enc) return 'Products in this piece';
      var oil = it.o[0], ph = it.p[0];
      if (oil && ph === oil) return 'Shop the oil';
      if (ph && ph === blendHandle) return 'Find it in';
      return 'Start here';
    }
    function related(it) {
      var tags = it.o;
      var score = function (o) { return o.o.filter(function (x) { return tags.indexOf(x) > -1; }).length; };
      var others = items.filter(function (o) { return o.id !== it.id; });
      var cand = others.filter(function (o) { return o.r !== it.r && score(o) > 0; }).sort(function (a, b) { return score(b) - score(a) || a.order - b.order; });
      var out = [], seen = {};
      cand.forEach(function (o) { if (out.length < 6 && (seen[o.r] || 0) < 2) { out.push(o); seen[o.r] = (seen[o.r] || 0) + 1; } });
      others.forEach(function (o) { if (out.length < 6 && o.r === it.r && out.indexOf(o) < 0) out.push(o); });
      return out;
    }
    function fillMedia(box, it, big) {
      box.innerHTML = '';
      box.className = (big ? 'flab-sm' : 'flab-rm') + ' flab-tone--' + (it.v === 'course' ? 'video' : it.v === 'study' ? 'molecule' : it.v);
      if (it.i) {
        var img = new Image();
        img.src = it.i;
        img.alt = '';
        img.loading = 'lazy';
        box.appendChild(img);
      } else {
        box.appendChild(icon(it.v === 'video' || it.v === 'course' ? 'play' : 'image', big ? 48 : 26));
      }
    }
    function openItem(id, fromLoad) {
      var it = byId[id];
      if (!it) return false;
      currentItem = it;
      fillMedia(sheet.querySelector('[data-flab-smedia]'), it, true);
      sheet.querySelector('[data-flab-srow]').textContent = it.rt || '';
      sheet.querySelector('[data-flab-stitle]').textContent = it.t;
      sheet.querySelector('[data-flab-smeta]').textContent = it.m || '';
      sheet.querySelector('[data-flab-sdesc]').textContent = it.x || '';

      var isCourse = it.v === 'course';
      var courseBox = sheet.querySelector('[data-flab-scourse]');
      courseBox.hidden = !isCourse;
      var cta = sheet.querySelector('[data-flab-scta]');
      var buy = sheet.querySelector('[data-flab-sbuy]');
      if (isCourse) {
        sheet.querySelector('[data-flab-spros]').textContent = it.pros || '';
        sheet.querySelector('[data-flab-sprice]').textContent = (it.price || '') + ' per course';
        cta.textContent = it.cta || 'Register as a professional';
        cta.href = it.reg || '#';
        buy.hidden = false;
        buy.textContent = 'Buy for ' + (it.price || '');
        buy.href = it.u;
      } else {
        cta.textContent = it.cta || 'Read article';
        cta.href = it.u;
        buy.hidden = true;
      }

      var pw = sheet.querySelector('[data-flab-sprods-wrap]');
      var pl = sheet.querySelector('[data-flab-sprods]');
      pl.innerHTML = '';
      var plist = it.p.map(function (h) { return products[h] ? { h: h, d: products[h] } : null; }).filter(Boolean);
      pw.hidden = !plist.length;
      sheet.querySelector('[data-flab-splabel]').textContent = productLabel(it) || 'Products in this piece';
      plist.forEach(function (p) {
        var a = el('a', 'flab-pcard');
        a.href = p.d.u;
        var im = el('span', 'flab-pimg');
        if (p.d.i) { var pi = new Image(); pi.src = p.d.i; pi.alt = ''; pi.loading = 'lazy'; im.appendChild(pi); } else { im.appendChild(icon('bottle', 26)); }
        var tx = el('span');
        tx.appendChild(el('span', 'flab-pn', p.d.t));
        tx.appendChild(el('span', 'flab-pp', p.d.pr));
        tx.appendChild(el('span', 'flab-pv', 'View product'));
        a.appendChild(im);
        a.appendChild(tx);
        pl.appendChild(a);
      });

      var rw = sheet.querySelector('[data-flab-srel-wrap]');
      var rl = sheet.querySelector('[data-flab-srel]');
      rl.innerHTML = '';
      var rel = related(it);
      rw.hidden = !rel.length;
      rel.forEach(function (o) {
        var a = el('a', 'flab-rcard');
        a.href = o.u;
        a.setAttribute('data-flab-item', o.id);
        var m = el('span');
        fillMedia(m, o, false);
        a.appendChild(m);
        a.appendChild(el('span', 'flab-rrow', o.rt));
        a.appendChild(el('span', 'flab-rt', o.t));
        rl.appendChild(a);
      });

      showLayer(sheet);
      var body = sheet.querySelector('[data-flab-sbody]');
      body.scrollTop = 0;
      if (!fromLoad) setOpenParam(it.id);
      var closeBtn = sheet.querySelector('.flab-sclose');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
      return true;
    }

    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-flab-item]');
      if (!a || !root.contains(a)) return;
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var id = a.getAttribute('data-flab-item');
      if (byId[id]) {
        e.preventDefault();
        openItem(id);
      }
    });

    var shareBtn = root.querySelector('[data-flab-share]');
    if (shareBtn) shareBtn.addEventListener('click', function () {
      if (!currentItem) return;
      var url = shareBase + '?open=' + encodeURIComponent(currentItem.id);
      if (navigator.share) {
        navigator.share({ title: currentItem.t, url: url }).catch(function () {});
        return;
      }
      var done = function () { showToast('Link copied. It opens this preview directly.'); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, done); else done();
    });
    var toastTimer;
    function showToast(msg) {
      if (!toast) return;
      toast.textContent = msg;
      toast.hidden = false;
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.hidden = true; }, 2800);
    }

    /* ---------- Search and browse ---------- */
    var q = search ? search.querySelector('[data-flab-q]') : null;
    var results = search ? search.querySelector('[data-flab-results]') : null;

    function rowInfo() {
      return rows.map(function (r) {
        var z = r.closest('.flab-zone');
        var zl = z ? z.querySelector('.flab-zhead') : null;
        var count = parseInt(r.getAttribute('data-flab-count') || '0', 10);
        var unit = r.hasAttribute('data-flab-enc') ? (count === 1 ? ' entry' : ' entries') : (count === 1 ? ' piece' : ' pieces');
        return {
          id: r.getAttribute('data-flab-row'),
          title: (r.querySelector('.flab-rtitle') || {}).textContent || '',
          zone: zl ? zl.textContent.trim() : '',
          label: count > 0 ? count + unit : 'Coming soon'
        };
      });
    }
    function renderBrowse() {
      results.innerHTML = '';
      if (picks.length) {
        results.appendChild(el('div', 'flab-eyebrow flab-eyebrow--muted flab-note', 'Popular searches'));
        var pills = el('div', 'flab-pills');
        picks.forEach(function (p) {
          var b = el('button', null, p);
          b.type = 'button';
          b.addEventListener('click', function () { q.value = p; renderResults(); q.focus(); });
          pills.appendChild(b);
        });
        results.appendChild(pills);
      }
      results.appendChild(el('div', 'flab-eyebrow flab-eyebrow--muted flab-note', 'Browse collections'));
      var zone = null;
      rowInfo().forEach(function (r) {
        if (r.zone !== zone) { zone = r.zone; if (zone) results.appendChild(el('div', 'flab-bz', zone)); }
        var b = el('button', 'flab-brow');
        b.type = 'button';
        var s = el('span');
        s.appendChild(el('span', null, r.title));
        s.appendChild(el('span', 'flab-card__meta', r.label));
        b.appendChild(s);
        b.appendChild(icon('next', 18));
        b.addEventListener('click', function () { closeLayer(); jumpTo(r.id); });
        results.appendChild(b);
      });
    }
    function renderResults() {
      var raw = (q.value || '').trim();
      var nq = norm(raw);
      if (!nq) { renderBrowse(); return; }
      results.innerHTML = '';
      var hits = items.filter(function (i) { return i.n.indexOf(nq) > -1; });
      results.appendChild(el('div', 'flab-note', hits.length ? hits.length + (hits.length === 1 ? ' result' : ' results') + ' for “' + raw + '”' : 'No matches for “' + raw + '” in this page.'));
      rowInfo().forEach(function (r) {
        var group = hits.filter(function (h) { return h.r === r.id; });
        if (!group.length) return;
        results.appendChild(el('div', 'flab-bz', r.title));
        group.forEach(function (h) {
          var a = el('a', 'flab-brow');
          a.href = h.u;
          a.setAttribute('data-flab-item', h.id);
          var s = el('span');
          s.appendChild(el('span', null, h.t));
          s.appendChild(el('span', 'flab-card__meta', h.m || ''));
          a.appendChild(s);
          a.appendChild(icon('next', 18));
          results.appendChild(a);
        });
      });
      var all = el('a', 'flab-brow');
      all.href = '/search?q=' + encodeURIComponent(raw);
      var s2 = el('span');
      s2.appendChild(el('span', null, 'Search the whole store for “' + raw + '”'));
      all.appendChild(s2);
      all.appendChild(icon('next', 18));
      results.appendChild(all);
    }
    function openSearch() {
      if (!search) return;
      showLayer(search);
      renderResults();
      setTimeout(function () { q.focus({ preventScroll: true }); }, 60);
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-flab-open-search]'), function (b) {
      b.addEventListener('click', openSearch);
    });
    if (q) q.addEventListener('input', renderResults);

    /* ---------- Chips, scroll spy, rows ---------- */
    function jumpTo(id) {
      var row = document.getElementById('flab-row-' + id);
      if (!row) return;
      var y = window.pageYOffset;
      var barH = bar ? bar.offsetHeight : 0;
      var target = row.getBoundingClientRect().top + y - barH - 4;
      target -= headerOverlap(target < y);
      window.scrollTo({ top: Math.max(0, target), behavior: behavior });
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function (e) {
        e.preventDefault();
        jumpTo(c.getAttribute('data-flab-chip'));
      });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-flab-step]'), function (b) {
      b.addEventListener('click', function () {
        var t = document.getElementById(b.getAttribute('aria-controls'));
        if (!t) return;
        var dir = parseInt(b.getAttribute('data-flab-step'), 10) || 1;
        t.scrollBy({ left: dir * Math.max(240, t.clientWidth * 0.85), behavior: behavior });
      });
    });
    if (topBtn) topBtn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: behavior }); });

    // Where the bar would sit if it weren't pinned. The marker can't be relied on alone: the theme hides empty divs.
    function naturalTop() {
      if (!bar) return null;
      if (sentinel && sentinel.getClientRects().length) return sentinel.getBoundingClientRect().top;
      var prev = bar.previousElementSibling;
      while (prev && !prev.getClientRects().length) prev = prev.previousElementSibling;
      return prev ? prev.getBoundingClientRect().bottom : null;
    }

    var active = null;
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var barRect = bar ? bar.getBoundingClientRect() : { top: 0, bottom: 0 };
        // The bar is pinned once the spot it sits in has scrolled past it. This holds while the header animates.
        var spot = naturalTop();
        var stuck = spot === null ? barRect.top <= headerVisibleHeight() + 1 : spot < barRect.top - 1;
        root.classList.toggle('is-stuck', stuck);
        var line = barRect.bottom + 72;
        // The current row, plus any row sitting next to it
        var tops = rows.map(function (r) { return r.getBoundingClientRect().top; });
        var curTop = null;
        tops.forEach(function (t) { if (t <= line) curTop = t; });
        var on = [];
        if (curTop !== null) rows.forEach(function (r, i) { if (Math.abs(tops[i] - curTop) < 2) on.push(r.getAttribute('data-flab-row')); });
        var key = on.join('|');
        if (key !== active) {
          active = key;
          var first = null;
          chips.forEach(function (c) {
            var isOn = on.indexOf(c.getAttribute('data-flab-chip')) > -1;
            c.classList.toggle('is-active', isOn);
            if (isOn && !first) { first = c; c.setAttribute('aria-current', 'true'); } else c.removeAttribute('aria-current');
          });
          if (first && chipsNav) chipsNav.scrollTo({ left: Math.max(0, first.offsetLeft - 16), behavior: behavior });
        }
        if (topBtn) topBtn.hidden = window.pageYOffset < 1100;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    if (bar) bar.addEventListener('transitionend', onScroll);
    onScroll();

    /* ---------- Deep links ---------- */
    try {
      var openId = new URL(location.href).searchParams.get('open');
      if (openId && byId[openId]) openItem(openId, true);
    } catch (e) {}
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-flab]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
